let selectedRule = {};
const SelectedRule = {
  getSelectedRule: () => selectedRule,
  setSelectedRule: (rule) => selectedRule = rule,
};

export default SelectedRule;
